import { Transaction } from 'prosemirror-state'
import { Node } from 'prosemirror-model'

const removeRevision = (tr: Transaction, node: Node, pos: number) => {
  tr.setNodeMarkup(
    pos,
    // @ts-ignore
    null,
    {
      ...node.attrs,
      aiRevision: null,
    },
    node.marks,
  )

  return true
}

export const clearRevisionMarks = (tr: Transaction) => {
  const schema = tr.doc.type.schema
  tr.removeMark(0, tr.doc.nodeSize - 2, schema.marks.ai_revision)

  tr.doc.descendants((node, pos) => {
    if (node.type.spec.attrs?.aiRevision) {
      return removeRevision(tr, node, pos)
    }
  })

  return tr
}
